import React from 'react';
import '../App.css';
import Header from './Header';
import zubayr from '../assets/profile_pics/zb.jpg';
import eesha from '../assets/profile_pics/es.jpg';
import david from '../assets/profile_pics/dvd.jpg';
import diyona from '../assets/profile_pics/dy.jpg';
import issy from '../assets/profile_pics/iz.jpg';

const teamMembers = [
        {
            name: "Issobel Dipple",
            position: "Head of Research",
            description: "Passionate about uncovering user needs, Issy drives our continuous improvement by refining ideas through insightful, iterative research.",
            image: issy
        },
        {
            name: "Diyona Dsouza",
            position: "Head of Customer Success",
            description: "Committed to mastering financial insights and collaborative problem-solving, Diyona ensures our customer’s needs are met and feedback is taken onboard.",
            image: diyona
        },
        {
            name: "Eesha Sondhi",
            position: "Chief Technology Officer",
            description: "Leveraging her expertise in machine learning and backend optimisation, Eesha guarantees smooth performance and robust technical validation for our product.",
            image: eesha
        },
        {
            name: "David Chen",
            position: "Chief Design Officer",
            description: "With a robust front-end background and a keen eye for the bigger picture, David seamlessly integrates technology, user experience, and strategy into our product development.",
            image: david
        },
        {
            name: "Zubayr Ghufoor",
            position: "Chief Executive Officer",
            description: "Balancing structure with adaptability and championing open communication, Zubayr leads our team with decisive vision and resilience.",
            image: zubayr
        }
    ];

function AboutUs() {
    return (
        <div>
            <Header />
            <div className="about-us-container">
                <div className="team-section">
                    <h2>Meet Our Team</h2>
                    <div className="team-grid">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="team-member">
                                <div className="member-image">
                                    <img src={member.image} alt={member.name} />
                                </div>
                                <h3>{member.name}</h3>
                                <h4>{member.position}</h4>
                                <p>{member.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;